import React from 'react';
import { SVAppDataGrid } from '@trackman/baseball-shared-components';
import styled from 'styled-components';
import { brand, reviewErrorBgEven, reviewErrorBgOdd, reviewSuccessBgEven, reviewSuccessBgOdd, white } from 'styles/Colors';

export const GridWrapper = styled.div`
  /* position: relative; */
`;

export const StyledDataGrid = styled((props) => <SVAppDataGrid {...props} />)`
  transition: height 0.3s ease-in-out;

  .inning-editor {
    overflow: visible !important;
  }

  .data-grid-content-cell {
    &.created {
      background-color: ${reviewSuccessBgOdd};
      &.even {
        background-color: ${reviewSuccessBgEven};
      }
    }
    &.deleted {
      background-color: ${reviewErrorBgOdd};
      &.even {
        background-color: ${reviewErrorBgEven};
      }
    }
  }
` as typeof SVAppDataGrid;

export const PlayerHighlightButtons = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  width: 100%;
  bottom: -10px;
`;

export const PlayerHighlistBtn = styled.div`
  background: ${brand};
  color: ${white};
  border-radius: 12px;
  display: flex;
  padding-left: 5px;
  padding-right: 5px;
  cursor: pointer;
  font-size: 12px;
  margin-right: 3px;
  margin-left: 3px;
  pointer-events: auto;
`;
